import { translate, translateFormatter, type RichTextFormatter } from '@/core/localization/translate';
export const {
  manoFulfillmentLabelFree,
  manoFulfillmentLabelFreeExpress
} = translate({
  "manoFulfillmentLabelFree": "Free delivery by Manomano",
  "manoFulfillmentLabelFreeExpress": "Free delivery 48h by ManoMano"
});
export const manoFulfillmentModalContent = translateFormatter<{
  name: string;
  tag: RichTextFormatter;
}>([{
  "type": 8,
  "value": "tag",
  "children": [{
    "type": 0,
    "value": "Dispatched by "
  }, {
    "type": 1,
    "value": "name"
  }, {
    "type": 0,
    "value": " for free"
  }]
}, {
  "type": 8,
  "value": "tag",
  "children": [{
    "type": 0,
    "value": "Under some conditions"
  }]
}], undefined, undefined, "en");
export const manoFulfillmentModalContentReturn = translateFormatter<{
  name: string;
  tag: RichTextFormatter;
}>([{
  "type": 8,
  "value": "tag",
  "children": [{
    "type": 0,
    "value": "Dispatched by "
  }, {
    "type": 1,
    "value": "name"
  }, {
    "type": 0,
    "value": " for free"
  }]
}, {
  "type": 8,
  "value": "tag",
  "children": [{
    "type": 0,
    "value": "Under some conditions and for 100 days"
  }]
}], undefined, undefined, "en");
export const manoFulfillmentLabelFreeReturn = translateFormatter<{
  name: string;
}>([{
  "type": 0,
  "value": "Livraison en 48h gratuite et retours gratuits pendant 100 jours par "
}, {
  "type": 1,
  "value": "name"
}], undefined, undefined, "en");